import React from "react";
import {motion} from "framer-motion";
import {Text, Link, Image} from "../components";

const Projects = () =>
{
    return (
            <motion.div 
                initial={{ opacity: 0}}
                animate={{opacity: 1}}
                exit={{opacity: 0}} 
            >
            <Text type="h1">Projects</Text>

            <Text type="h4">
                <Link to="/WeatherApp">WeatherApp (Practice Assignment)</Link>
            </Text>

            <Image source="https://sharedassets39.blob.core.windows.net/resources/weatherApp.png">Used <Link to="https://openweathermap.org/">OpenWeatherAPI</Link> to display current weather information</Image>

            <Text classname="p">
                Not a complex application, but it refreshed my understanding of writing/making asynchronous GET requests to an external API.  Maybe I should add the current date and time to the top of the page 🤔
            </Text>

            <Text type="h4">
                <Link to="/word-scrambler">Word Scrambler (Hatchways assingment)</Link>
            </Text>

            <Image source="https://sharedassets39.blob.core.windows.net/resources/word-scramble.gif">Learned the use of useRef hook, and not to manipulate the DOM</Image>
            
            <Text classname="p">
                Scrambles sentences got from an API.  Looks easy to implement but has some quirks such as the auto-focusing mechanic.
            </Text>

            <Text type="h4">
                <Link to="/student-profiles">Student Profiles (Hatchways assingment)</Link>
            </Text>

            <Image source="https://sharedassets39.blob.core.windows.net/resources/student-profiles.gif">First React assignment ever!!</Image>
            
            <Text classname="p">
                Gets data via public api.  Features include: add tags, expand button to show more student details, filter results by name, and filter by tag.
            </Text>

            <Text type="h4">
                <Link to="https://github.com/CosmanAgraz/MMBN3-Randomizer">Megaman Battle Network 3 Randomizer (GUI)</Link>
            </Text>
            
            <Image source="https://sharedassets39.blob.core.windows.net/resources/mmbn3.gif">Remember to save often!</Image>

            <Text classname="p">
                Looking for a fun way to play Megaman Battle Network 3?
            </Text>

            <Text classname="p">
                Credits: XKirby, Mountebank/Samfin, Dabomstew, Prof.9, Rockman.EXE and TeamBN
            </Text>

            <Text type="h4">
                <Link to="https://discord.com/api/oauth2/authorize?client_id=381961028486823939&permissions=67584&scope=bot">Shyvana-bot</Link>
            </Text>

            <Image source="https://sharedassets39.blob.core.windows.net/resources/sample.PNG">Friendship preservation is not guaranteed</Image>
            
            <Text classname="p">
                A <Link to="https://discord.com/">Discord</Link> bot I made for generating brave (random) <Link to="https://leagueoflegends.com/">League of Legends</Link> builds directly to your Discord server.
            </Text>

            <Text classname="p">
                Inspired by: <Link to="https://ultimate-bravery.net/">Ultimate Bravery</Link>
            </Text>
            
            
        </motion.div>
    )
}

Projects.defaultProps = {};

export default Projects;